import './ModalPdfViewer.scss';
import React, {useEffect, useState} from 'react';
import {getFormFilePromise} from './promises';
import {Spin} from 'antd';

const ModalPdfViewer = ({pdfId}) => {
    const [url, setUrl] = useState(null)
    const [fileName, setFileName] = useState('')

    useEffect(() => {
        const loadPdf = async () => {
            const response = await getFormFilePromise(pdfId);
            const fileName = (response.headers['x-folio'] || 'file') + '.pdf';
            setFileName(fileName);
            const blob = await response.data;
            const url = URL.createObjectURL(blob);
            setUrl(url);
        }
        loadPdf();
    }, [])

    return (
        url === null ? 
            <div className="spin-pdf-viewer">
                <Spin spinning={true} size="large" centered={true}/> 
            </div>
            :
            <iframe src={url} frameBorder="0" width="100%" height="100%"></iframe>
    )
}

export default ModalPdfViewer
